import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from '../taiwan_pcb/store';
import App from '../taiwan_pcb/App';
import Cart from '../taiwan_pcb/cart/Cart';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('quote-form');
  const cartContainer = document.getElementById('cart-form');
  if (appContainer == null || cartContainer == null) {
    return;
  }

  render(
    <Provider store={store}>
      <App />
    </Provider>,
    appContainer,
  );
  render(
    <Provider store={store}>
      <Cart />
    </Provider>,
    cartContainer,
  );
});
